import { rem } from 'polished';
import styled from 'styled-components';

const ColorNameTitle = styled.div`
    min-height: ${rem(32)};
    padding-bottom: ${rem(8)};
`;

export default ColorNameTitle;
